import { useRef, useEffect } from 'react';

interface WhisperTextProps {
  text: string;
  align?: 'left' | 'center' | 'right';
}

export default function WhisperText({ text, align = 'center' }: WhisperTextProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100');
            entry.target.classList.remove('opacity-0');
          }
        });
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`w-full py-14 px-6 opacity-0 transition-opacity duration-1500 bg-[#FAF8F5] text-${align}`}
    >
      <p
        className="font-serif text-lg md:text-xl tracking-widest max-w-xl mx-auto"
        style={{ color: 'rgba(143, 166, 139, 0.7)' }}
      >
        {text}
      </p>
    </div>
  );
}
